import {IExportFlow, IExportTemplate, IMessageData, IObjectType, IRouteDefinitionParams} from "../../../index";
import * as ko from "knockout";
import {nsParentPath} from "./fn";
import {createErrorMessage} from "../../../util/misc";
import {nsRoute} from "../../../util/route";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import readHtml from './read.html?raw';

export let template: string = readHtml;

interface IParams extends IRouteDefinitionParams {
    objecttype: IObjectType
}

export class viewModel extends ParsedRouteDataDecorator {

    TYPE = nsParentPath.TYPE;
    isReady: KnockoutObservable<boolean> = ko.observable(false);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    hasMultiple!: boolean;
    exportflow!: IExportFlow[];
    objecttype: IObjectType;

    constructor(params: IParams) {
        super(params);
        this.objecttype = params.objecttype;
        this.initRequest();
    }

    private initRequest() {
        this.isReady(false);
        this.__requestRouteData?.request()
            .then((data: IExportTemplate[]) => {
                const template = data[0];
                if (!template) {
                    return;
                }
                this.objecttype = template.objecttype;
                this.exportflow = this.getRelevantExportFlows(template.exportflow);
                this.hasMultiple = this.exportflow.length > 1;
                if (!this.exportflow.length) {
                    this.messageData({message: `no data`});
                }
            })
            .then(() => this.isReady(true))
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
    }

    getRelevantExportFlows(exportflow: IExportFlow[]): IExportFlow[] {
        return exportflow.filter((item: IExportFlow) => item.targetattribute == "parentPath");
    }

    getAbsolutePath(expression: string): string[] {
        return expression.split(",");
    }

    getType = nsParentPath.getTypeFromExportFlow;
    getTypeLabel = nsParentPath.getTypeLabelFromExportFlow;

}
